module.exports = __webpack_public_path__ + "static/media/right.20f75fe3.svg";